import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ImpersonationService } from './impersonation.service';

@Component({
    standalone: true,
    selector: 'abs-impersonation-bar',
    imports: [CommonModule, IonicModule],
    template: `
        @if (impersonationService.isImpersonating()) {
            <div class="impersonation-bar">
                <span class="label">Impersonating roles:</span>
                @for (role of impersonationService.currentImpersonatedRoles(); track role) {
                    <ion-chip>
                        <ion-label>{{ role }}</ion-label>
                        <ion-icon name="close-circle" (click)="removeRole(role)"></ion-icon>
                    </ion-chip>
                }
                <ion-button size="small" color="light" fill="clear" (click)="impersonationService.stopImpersonation()"> Stop </ion-button>
            </div>
        }
    `,
    styles: [
        `
            .impersonation-bar {
                display: flex;
                align-items: center;
                gap: 4px;
                padding: 4px 12px;
                background: #d32f2f;
                color: #fff;
                font-size: 13px;
                z-index: 9999;
                flex-wrap: wrap;
            }
            .label {
                font-weight: 600;
                margin-right: 4px;
            }
            ion-chip {
                height: 26px;
                font-size: 12px;
                --background: rgba(255, 255, 255, 0.2);
                --color: #fff;
            }
        `
    ]
})
export class ImpersonationBarComponent {
    impersonationService = inject(ImpersonationService);

    removeRole(role: string) {
        const current = this.impersonationService.currentImpersonatedRoles();
        this.impersonationService.updateRoles(current.filter((r) => r !== role));
    }
}
